const ukrainian = {
    'STAFF_MANAGEMENT.Title_Point': "Точка відмітки приходу",
    'STAFF_MANAGEMENT.Title_Attendance': "Відвідуваність",
    'STAFF_MANAGEMENT.UseLocation': "Використати моє місцеположення",
    'STAFF_MANAGEMENT.SetPoint': "Встановити точку відмітки приходу",
    'STAFF_MANAGEMENT.SetPointHelp': "Станьте в місці, де працівники відмічають прихід, і збережіть своє місцеположення.",
    'STAFF_MANAGEMENT.CheckPin': "Перевірте, чи це правильне місце",
    'STAFF_MANAGEMENT.CheckSpot': "Перевірте позначку та збережіть",
    'STAFF_MANAGEMENT.Retake': "Повторити",
    'STAFF_MANAGEMENT.Save': "Зберегти",
    'STAFF_MANAGEMENT.Saving': "Зберігаємо точку відмітки приходу…",
    'STAFF_MANAGEMENT.Locating': "Уточнюємо ваше місцеположення. Залишайтеся в місці відмітки приходу — це може тривати до 15 секунд.",
    'STAFF_MANAGEMENT.LocationAccuracy': "Орієнтовна точність: { accuracy } м",
    'STAFF_MANAGEMENT.LocationAccuracyUnknown': "Орієнтовна точність недоступна",
    'STAFF_MANAGEMENT.LowAccuracyTitle': "Низька точність місцеположення",
    'STAFF_MANAGEMENT.LowAccuracyHelp': "Перевірте точку на карті або визначте місцеположення знову.",
    'STAFF_MANAGEMENT.LocationPermission': "Дозвольте доступ до місцеположення в налаштуваннях браузера та спробуйте ще раз.",
    'STAFF_MANAGEMENT.LocationTimeout': "Не вдалося вчасно визначити місцеположення. Залишайтеся в місці відмітки приходу та спробуйте ще раз.",
    'STAFF_MANAGEMENT.LocationUnavailable': "Ваше місцеположення недоступне. Перевірте налаштування геолокації пристрою та спробуйте ще раз.",
    'STAFF_MANAGEMENT.MapUnavailable': "Не вдалося завантажити карту. Спробуйте ще раз.",
    'STAFF_MANAGEMENT.Ready': "Готово до відмітки приходу",
    'STAFF_MANAGEMENT.UpdateLocation': "Оновити місцеположення",
    'STAFF_MANAGEMENT.ViewQr': "Переглянути QR-код",
    'STAFF_MANAGEMENT.PointCreated': "Точку відмітки приходу створено",
    'STAFF_MANAGEMENT.PointUpdated': "Точку відмітки приходу оновлено",
    'STAFF_MANAGEMENT.SaveError': "Не вдалося підтвердити збереження. Перевірте з’єднання та спробуйте ще раз.",
    'STAFF_MANAGEMENT.NoManageAccess': "Ви не маєте дозволу встановлювати або змінювати цю точку відмітки приходу.",
    'STAFF_MANAGEMENT.NoAttendanceAccess': "Ви не маєте дозволу переглядати відвідуваність працівників.",
    'STAFF_MANAGEMENT.SelectExhibition': "Спочатку виберіть захід.",
    'STAFF_MANAGEMENT.Loading': "Завантаження…",
    'STAFF_MANAGEMENT.Retry': "Спробувати ще раз",
    'STAFF_MANAGEMENT.Back': "Назад",
    'STAFF_MANAGEMENT.QrTitle': "QR-код для відмітки приходу",
    'STAFF_MANAGEMENT.QrMissing': "QR-код для відмітки приходу ще недоступний.",
    'STAFF_MANAGEMENT.QrError': "Не вдалося завантажити QR-код. Спробуйте ще раз.",
    'STAFF_MANAGEMENT.DownloadPdf': "Завантажити PDF",
    'STAFF_MANAGEMENT.PdfLoading': "Готуємо PDF…",
    'STAFF_MANAGEMENT.PdfError': "Не вдалося створити PDF. Спробуйте ще раз.",
    'STAFF_MANAGEMENT.Today': "Сьогодні",
    'STAFF_MANAGEMENT.ChooseDate': "Вибрати дату",
    'STAFF_MANAGEMENT.ChooseCompany': "Вибрати компанію",
    'STAFF_MANAGEMENT.AllCompanies': "Усі компанії",
    'STAFF_MANAGEMENT.Apply': "Застосувати",
    'STAFF_MANAGEMENT.NoCheckIn': "Прихід не відмічено",
    'STAFF_MANAGEMENT.In': "Прихід",
    'STAFF_MANAGEMENT.Out': "Вихід",
    'STAFF_MANAGEMENT.Working': "Працює",
    'STAFF_MANAGEMENT.Completed': "Завершено",
    'STAFF_MANAGEMENT.FailedCheckout': "Не вдалося відмітити вихід",
    'STAFF_MANAGEMENT.MissedCheckout': "Вихід не відмічено",
    'STAFF_MANAGEMENT.UnknownStatus': "Невідомий статус",
    'STAFF_MANAGEMENT.NoAttendanceRecords': "За цю дату немає записів відвідуваності.",
    'STAFF_MANAGEMENT.NoMatches': "За вибраними фільтрами працівників не знайдено.",
    'STAFF_MANAGEMENT.AttendanceError': "Не вдалося завантажити відвідуваність. Спробуйте ще раз.",
    'STAFF_MANAGEMENT.UnknownCompany': "Компанію не вказано",
    'STAFF_MANAGEMENT.LoadPointError': "Не вдалося завантажити точку відмітки приходу. Спробуйте ще раз.",
    'STAFF_MANAGEMENT.PosterTitle': "Відмітка приходу / виходу",
    'STAFF_MANAGEMENT.PosterInstructions': "Відкрийте застосунок ELFE та відскануйте цей QR-код на початку й наприкінці роботи.",
    'STAFF_MANAGEMENT.PosterGenerated': "QR-код створено: { date }",
    'PHOTO_SOURCE.TakePhoto' : 'Зробити фото',
    'PHOTO_SOURCE.ChooseFromGallery' : 'Вибрати з галереї',
    'CRAFT.Type_Logistics' : 'Логістика { number }',
    'CRAFT.Type_Floor' : 'Підлога { number }',
    'CRAFT.Type_Assembly' : 'Монтаж { number }',
    'CRAFT.Type_Electrics' : 'Електрика { number }',
    'CRAFT.Type_Graphic' : 'Графіка { number }',
    'CRAFT.Type_Furniture' : 'Меблі { number }',
    'CRAFT.Type_Multimedia' : 'Мультимедіа { number }',
    'CRAFT.Type_Cleaning' : 'Прибирання { number }',
    'CRAFT.Type_Additional' : 'Додаткове { number }',
    'CRAFT.Type_MPControl' : 'MP контроль',
    'CRAFT.Type_Protocol' : 'Протокол',
    'CRAFT.Type_Service' : 'Сервіс { number }',
    'CRAFT.Type_CollectGraphics' : 'Забрати графіку',
    'CRAFT.Status_Text_InProgress' : 'В роботі',
    'CRAFT.Status_Text_Disabled' : 'Вимкнено',
    'CRAFT.Status_Text_Completed' : 'Завершено',
    'CRAFT.Status_Text_Overdue' : 'Прострочено',
    'CRAFT.Status_Text_Done' : 'Зібрано',
    'CRAFT.Status_Text_Open' : 'Відкрито',
    'CRAFT.Status_Text_Collected': 'Зібрано',
    'CRAFT.Status_Warning_Cannot_Change_Done': 'Неможливо змінити статус: графіку вже оброблено в адмін-панелі',
    'CRAFT.Button_ViewAll' : 'Показати все',
    'CRAFT.Button_Text_Print' : 'Друк',
    'CRAFT.Button_Text_Stand' : 'Стенд',
    'CRAFT.Button_Text_MarkOpen' : 'Позначити роботу відкритою',
    'CRAFT.Button_Text_MarkDone' : 'Позначити роботу виконаною',
    'CRAFT.Button_Text_MarkInProgress' : 'Позначити роботу в процесі',
    'CRAFT.Button_ChangeStatus_InProgress' : 'В роботі',
    'CRAFT.Button_ChangeStatus_Done': 'Готово',
    'CRAFT.Button_Text_ShelfNumber' : '№ полиці',
    'CRAFT.Filter_Params_CraftType' : 'Роботи: { withFilter }',
    'EXHIBITION.Select_Instruction' : 'Виберіть подію { br } зі списку нижче',
    'EXHIBITION.Select_Label' : 'ВИБРАНА ПОДІЯ',
    'EXHIBITION.Modal_Title' : 'ВИБЕРІТЬ ПОДІЮ',
    'EXHIBITION.Timer_State_Underway' : 'ТРИВАЄ',
    'EXHIBITION.Timer_State_Ended' : 'ЗАВЕРШЕНО',
    'EXHIBITION.Title_CraftTotal' : 'Огляд усіх робіт',
    'EXHIBITION.Statistic_Status_InTotal' : 'загалом',
    'EXHIBITION.Statistic_Status_InProgress' : 'в роботі',
    'EXHIBITION.Statistic_Status_Done' : 'готово',
    'EXHIBITION.Statistic_Status_Overdue' : 'прострочено',
    'EXHIBITION.Statistic_Status_NotApproved' : 'не затверджено',
    'EXHIBITION.Statistic_Status_BookedForExhibition' : 'призначено на виставку',
    'EXHIBITION.Statistic_Status_CheckedIn' : 'Відмітили прихід',
    'EXHIBITION.Statistic_Type_Stands' : 'Стенди',
    'EXHIBITION.Statistic_Type_Claims' : 'MP рекламації',
    'EXHIBITION.Statistic_Type_CustomerClaims' : 'Рекламації експонента',
    'EXHIBITION.Statistic_Type_LastMinute' : 'Термінові задачі',
    'EXHIBITION.Statistic_Type_MpControl' : 'MP контроль',
    'EXHIBITION.Statistic_Type_Damages' : 'Пошкодження',
    'EXHIBITION.Statistic_Type_Protocol' : 'Протокол',
    'EXHIBITION.Statistic_Type_Staff' : 'Персонал',
    'FORM.Textarea_Placeholder_JobDescription' : 'Опис задачі*',
    'FORM.Button_Text_AddJob' : 'Додати задачу',
    'FORM.Button_Text_SaveJob' : 'Зберегти задачу',
    'FORM.Button_AddJobPhoto' : 'Додати фото',
    'FORM_RULES.Required_Login' : 'Введіть логін',
    'FORM_RULES.Required_Password' : 'Введіть пароль',
    'FORM_RULES.Required_KeyDescription' : 'Введіть опис ключа',
    'FORM_RULES.Required_KeyNumber' : 'Введіть номер ключа',
    'FORM_RULES.Required_JobDescription' : 'Додайте опис задачі',
    'FORM_RULES.Required_Quantity' : 'Введіть кількість',
    'FORM_RULES.Min_Quantity' : 'Кількість має бути числом не менше одного',
    'FORMS.Input_Label_Login' : 'логін',
    'FORMS.Input_Label_Password' : 'пароль',
    'FORMS.Button_Text_Login' : 'Увійти',
    'FORMS.Input_Label_Description' : 'Опис',
    'FORMS.Input_Label_KeyNumber' : 'Номер ключа',
    'FORMS.Input_Label_Hall' : 'Зал',
    'FORMS.Input_Label_Stands' : 'Стенди',
    'FORMS.Button_Text_ApplyFilters' : 'Застосувати',
    'FORMS.Button_Text_ResetFilters' : 'Скинути фільтри',
    'FORMS.Select_DefaultValue_All' : 'Усе',
    'FORMS.Select_StandTypeValue_CraftInProgress' : 'З роботами в процесі',
    'FORMS.Select_StandTypeValue_CraftCompleted' : 'Із завершеними роботами',
    'FORMS.Select_StandTypeValue_ControlInProgress' : 'З контролем в процесі',
    'FORMS.Select_StandTypeValue_ProtocolInProgress' : 'З протоколом в процесі',
    'FORMS.Select_StandTypeValue_OverdueCrafts' : 'З простроченими роботами',
    'FORMS.Select_StandTypeValue_AdditionalJobs' : 'З додатковими задачами',
    'FORMS.Button_Text_ApplySort' : 'Застосувати',
    'FORMS.Input_Label_CraftType' : 'Тип робіт',
    'FORMS.Input_Label_JobType'   : 'Тип',
    'FORMS.Input_Label_JobFlag'   : 'Позначка',
    'FORMS.Input_Label_JobStatus' : 'Статус',
    'FORMS.Input_Label_CraftStatus' : 'Статус робіт',
    'FORMS.Input_Label_DamageStatus' : 'Статус пошкодження',
    'FORMS.Input_Label_Subcontractor' : 'Підрядник',
    'FORMS.Input_Label_Comments' : 'Коментарі',
    'FORMS.Select_JobStatusValue_JobsOpen' : 'Відкриті задачі',
    'FORMS.Select_JobStatusValue_JobsInProgress' : 'Задачі в роботі',
    'FORMS.Select_JobStatusValue_FinishedJobs' : 'Завершені задачі',
    'FORMS.Select_JobFlag_WithoutFlag' : 'Без позначки',
    'FORMS.Select_JobFlag_WithFlag' : 'З позначкою',
    'FORMS.Input_Label_FurnishingName' : 'Назва обладнання',
    'FORMS.Input_Label_FurnishingReturnQuantity' : 'Кількість',
    'FORMS.Input_Label_Quantity' : 'Кількість',
    'FORMS.Input_Label_CurrentQuantity' : 'Поточна кількість',
    'FORMS.Input_Label_NewQuantity' : 'Нова кількість',
    'FORMS.RadioInput_Text_Description' : 'Опис',
    'FORMS.RadioInput_Text_Furnishing' : 'Обладнання',
    'FORMS.RadioInput_Text_FurnishingClaim' : 'Обладнання',
    'FORMS.Input_Label_OrderType'   : 'Тип',
    'FORMS.Select_FurnishingOrder_Type_Return' : "Повернення артикулу",
    'FORMS.Select_FurnishingOrder_Type_Lost' : "Втрачено",
    'FORMS.Select_FurnishingOrder_Type_Correction' : "Зміна суми",
    'FORMS.Select_FurnishingOrder_Type_Order' : "Замовлення",
    'GLOBAL.Button_Text_Logout' : 'Вийти',
    'GLOBAL.Button_Text_Filter' : 'Фільтр',
    'GLOBAL.Button_Text_Sort' : 'Сортувати',
    'GLOBAL.Text_Version' : 'Версія { versionNumber }',
    'GLOBAL.Button_Text_Cancel' : 'Скасувати',
    'ATTENDANCE.Button_CheckIn': 'Прихід',
    'ATTENDANCE.Button_CheckOut': 'Вихід',
    'ATTENDANCE.SelectExhibitionFirst_Text': 'Спочатку виберіть виставку.',
    'ATTENDANCE.Button_RetryScan': 'Сканувати ще раз',
    'ATTENDANCE.Button_Close': 'Закрити',
    'ATTENDANCE.Modal_Title_CheckIn': 'Сканувати прихід',
    'ATTENDANCE.Modal_Title_CheckOut': 'Сканувати вихід',
    'ATTENDANCE.Scanner_Hint': 'Наведіть камеру на QR-код',
    'ATTENDANCE.Processing_Locating_Title': 'Уточнюємо ваше місцезнаходження…',
    'ATTENDANCE.Processing_Locating_Text': 'Будь ласка, залишайтеся на місці. Це може зайняти до 15 секунд.',
    'ATTENDANCE.Processing_Submitting_Title': 'Надсилаємо сканування...',
    'ATTENDANCE.Processing_Submitting_Text': 'Зачекайте. Зберігаємо робочий час.',
    'ATTENDANCE.Error_GpsPermission_Title': 'Потрібен доступ до геолокації',
    'ATTENDANCE.Error_GpsPermission_Text': 'Дозвольте доступ до геолокації у браузері та спробуйте ще раз.',
    'ATTENDANCE.Error_GpsTimeout_Title': 'Слабкий GPS-сигнал',
    'ATTENDANCE.Error_GpsTimeout_Text': 'Координати не знайдено. Підійдіть ближче до виходу та скануйте ще раз.',
    'ATTENDANCE.Error_GpsUnavailable_Title': 'GPS недоступний',
    'ATTENDANCE.Error_GpsUnavailable_Text': 'Дані місцезнаходження недоступні на цьому пристрої.',
    'ATTENDANCE.Error_Camera_Title': 'Камера недоступна',
    'ATTENDANCE.Error_Camera_Text': 'Дозвольте доступ до камери та спробуйте ще раз.',
    'ATTENDANCE.Error_CameraPermission_Title': 'Доступ до камери заблоковано',
    'ATTENDANCE.Error_CameraPermission_Text': 'Дозвольте доступ до камери в налаштуваннях сайту в браузері та спробуйте ще раз.',
    'ATTENDANCE.Error_CameraNotFound_Title': 'Камеру не знайдено',
    'ATTENDANCE.Error_CameraNotFound_Text': 'Цей пристрій не надає браузеру доступної камери.',
    'ATTENDANCE.Error_SecureContext_Title': 'Потрібен HTTPS',
    'ATTENDANCE.Error_SecureContext_Text': 'Камера та GPS у мобільному браузері працюють лише через HTTPS. Відкрийте застосунок через HTTPS/dev tunnel.',
    'ATTENDANCE.Error_Server_Title': 'Сканування не вдалося',
    'ATTENDANCE.Error_Server_Text': 'Сервер не обробив сканування. Перевірте інтернет-з’єднання та спробуйте ще раз.',
    'ATTENDANCE.Error_Generic_Title': 'Сканування не вдалося',
    'ATTENDANCE.Error_Generic_Text': 'Спробуйте ще раз.',
    'ATTENDANCE.Result_CheckInAccepted_Title': 'Прихід успішно збережено',
    'ATTENDANCE.Result_CheckOutAccepted_Title': 'Вихід успішно збережено',
    'ATTENDANCE.Result_Accepted_Text': 'Час: { serverTime }. Вас зафіксовано в системі.',
    'ATTENDANCE.Result_Duplicate_Title': 'Вже зафіксовано',
    'ATTENDANCE.Result_Duplicate_Text': 'Це сканування вже було збережено.',
    'ATTENDANCE.Result_OpenSessionElsewhere_Title': 'Прихід зафіксовано на іншій виставці',
    'ATTENDANCE.Result_OpenSessionElsewhere_Text': 'Перш ніж відмітити прихід тут, відмітьте вихід на тій виставці. Якщо ви не маєте доступу до неї, зверніться до свого керівника будівництва або керівника проєкту.',
    'ATTENDANCE.Result_ShiftClosed_Title': 'Зміну вже закрито',
    'ATTENDANCE.Link_MyTimeRecords': 'Переглянути мій робочий час',
    'ATTENDANCE.Result_ShiftClosed_Text': 'Вашу зміну вже закрито. Якщо ви не відмічали вихід, можливо, її закрив менеджер. Щоб розпочати нову зміну, відмітьте прихід.',
    'ATTENDANCE.Result_AlreadyCheckedIn_Title': 'Прихід уже зафіксовано',
    'ATTENDANCE.Result_AlreadyCheckedIn_Text': 'Відмітьте вихід із цієї виставки, перш ніж повторно відмітити прихід.',
    'ATTENDANCE.Result_Rejected_Title': 'Доступ відхилено',
    'ATTENDANCE.Result_OutsideRadius_Text': 'Ви занадто далеко від входу. Підійдіть ближче до входу.',
    'ATTENDANCE.Result_InvalidQr_Text': 'Цей QR-код недійсний для приходу/виходу.',
    'ATTENDANCE.Result_GenericRejected_Text': 'Сканування відхилено.',
    'ATTENDANCE.Button_Back': 'Назад',
    'ATTENDANCE.Button_TryAgain': 'Спробувати ще раз',
    'ATTENDANCE.Button_GotIt': 'Зрозуміло',
    'ATTENDANCE.Overview_NotCheckedIn': 'Прихід не зафіксовано',
    'ATTENDANCE.Overview_CheckInPrompt': 'Відмітьте прихід через QR-код',
    'ATTENDANCE.Overview_CheckedIn_Label': 'Ваш прихід зафіксовано',
    'ATTENDANCE.Overview_CheckedInAt': 'о { time }',
    'ATTENDANCE.Scanner_CheckIn_Hint': 'Перед початком роботи відскануйте QR-код, щоб відмітити прихід',
    'ATTENDANCE.Scanner_CheckOut_Hint': 'Для відмітки виходу наведіть камеру на QR-код на виставці',
    'ATTENDANCE.Error_StatusLoad_Text': 'Не вдалося завантажити статус приходу.',
    'ATTENDANCE.Error_CameraDesign_Title': 'Застосунок не може відкрити камеру',
    'ATTENDANCE.Error_CameraDesign_Text': 'Для відмітки приходу потрібно відсканувати код камерою телефона. Натисніть Спробувати ще раз і дозвольте доступ до камери.',
    'ATTENDANCE.Error_Camera_Settings_Hint': 'Не працює? Можливо, камера заблокована — перевірте дозволи сайту в браузері.',
    'ATTENDANCE.Error_LocationDesign_Title': 'Застосунок не бачить ваше місцезнаходження',
    'ATTENDANCE.Error_LocationDesign_Text': 'Для відмітки приходу потрібне місцезнаходження. Увімкніть його в налаштуваннях телефона та спробуйте ще раз.',
    'ATTENDANCE.Result_CheckedInAt': 'Ваш прихід зафіксовано { date } о { time }',
    'ATTENDANCE.Result_CheckInSuccessAt': 'Ви успішно відмітили прихід на роботу о { time }.',
    'ATTENDANCE.Result_CheckedOutAt': 'Ви завершили роботу та відмітили{ br }вихід о { time }',
    'ATTENDANCE.Result_OutsideRadius_Title': 'Ви повинні бути на місці проведення',
    'ATTENDANCE.Result_OutsideRadius_DesignText': 'Ваше місцезнаходження не відповідає виставці. Прихід фіксується через GPS. Спробуйте ще раз у потрібному місці.',
    'ATTENDANCE.Result_LowAccuracy_Title': 'Низька точність геолокації',
    'ATTENDANCE.Result_LowAccuracy_Badge': 'Точність: { accuracy } (Надто низька)',
    'ATTENDANCE.Result_LowAccuracy_CheckIn': 'Щоб відмітити прихід:',
    'ATTENDANCE.Result_LowAccuracy_CheckOut': 'Щоб відмітити вихід:',
    'ATTENDANCE.Result_LowAccuracy_PreciseLocation': 'Увімкніть «Точну геопозицію» для браузера в налаштуваннях телефону',
    'ATTENDANCE.Result_LowAccuracy_Wifi': 'Увімкніть Wi-Fi, щоб допомогти визначити місцезнаходження пристрою',
    'ATTENDANCE.Result_LowAccuracy_Retry': 'Потім натисніть { back } і відскануйте код ще раз.',
    'ATTENDANCE.Accuracy_Meters': '{ value } м',
    'ATTENDANCE.Accuracy_Kilometers': '{ value } км',
    'ATTENDANCE.Result_InvalidQr_Title': 'Це не той код',
    'ATTENDANCE.Result_InvalidQr_CheckIn_Title': 'Неможливо відмітити прихід!',
    'ATTENDANCE.Result_InvalidQr_CheckOut_Title': 'Неможливо відмітити вихід!',
    'ATTENDANCE.Result_InvalidQr_DesignText': 'Цей QR-код не належить до вашого заходу. Будь ласка, зверніться до свого керівника будівництва або керівника проєкту.',
    'ATTENDANCE.Result_OutdatedQr_Text': 'Цей QR-код застарів. Будь ласка, відскануйте актуальний QR-код.',
    'ATTENDANCE.Result_DeviceConflict_Title': 'Неможливо відмітити прихід!',
    'ATTENDANCE.Result_DeviceConflict_Text': 'Інша особа вже відмітила прихід за допомогою цього телефону. Застосунок не дозволяє двом різним користувачам відмічати прихід з одного пристрою!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Title': 'Сканування приходу неможливе!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Text': 'Відмітка приходу доступна лише протягом установленого періоду проведення заходу. Будь ласка, зверніться до свого керівника будівництва або керівника проєкту.',
    'ATTENDANCE.Result_OutsideSchedule_CheckOut_Title': 'Зараз відмітка виходу недоступна',
    'ATTENDANCE.Result_OutsideSchedule_Text': 'Ця дія доступна лише протягом налаштованого періоду виставки. Перевірте вибрану виставку та її дати.',
    'ATTENDANCE.TimeRecords_InProgress': 'в роботі',
    'ATTENDANCE.TimeRecords_Missed': 'пропущено',
    'ATTENDANCE.TimeRecords_Empty': 'Записів робочого часу ще немає.',
    'ATTENDANCE.Error_TimeRecordsLoad_Text': 'Не вдалося завантажити записи робочого часу.',
    'MENUS.Label_MyTimeRecords': 'Мій робочий час',
    'PAGE.Title_MyTimeRecords': 'Мій робочий час',
    'GLOBAL.Badge_Text_New' : 'НОВЕ',
    'GLOBAL.Modal_Title_Filters' : 'Фільтри',
    'GLOBAL.Modal_Title_SortBy' : 'Сортувати за',
    'GLOBAL.TimeLeft' : 'залишилось { timeLeft }',
    'GLOBAL.Text_Piece' : 'шт.',
    'GLOBAL.Button_Text_Confirm' : 'Підтвердити',
    'GLOBAL.Language_Default' : 'За замовчуванням',
    'TRANSLATION.Button_Text_Translate' : 'Перекласти',
    'TRANSLATION.Button_Text_TranslateInput' : 'Перекласти німецькою',
    'TRANSLATION.Button_Text_TranslateEnglish' : 'Перекласти англійською',
    'TRANSLATION.Button_Text_TranslateNative' : 'Перекласти моєю мовою',
    'TRANSLATION.Button_Text_ShowOriginal' : 'Показати німецький оригінал',
    'TRANSLATION.Text_InputTranslating' : 'Переклад...',
    'TRANSLATION.Text_InputTranslated' : 'Перекладено',
    'TRANSLATION.Text_InputTranslationError' : 'Не вдалося перекласти',
    'TRANSLATION.Text_InputTranslationRequired' : 'Перекладіть текст перед відправленням',
    'TRANSLATION.Text_ApiUnavailable' : 'Переклад зараз недоступний',
    'GLOBAL.Card_Hero_Hall' : 'Зал',
    'GLOBAL.Card_Hero_Block' : 'Блок',
    'GLOBAL.Card_Hero_Stand' : 'Стенд',
    'GLOBAL.Comment': 'Коментар',
    'HALL.Button_Text_HallPlan' : 'План залу',
    'HALL.Link_Text_HallPlan' : 'План залу { hallName }',
    'JOB.Tag_Claim' : 'C',
    'JOB.Tag_CustomerClaim' : 'C',
    'JOB.Tag_MPAndCustomerClaim' : 'C',
    'JOB.Tag_LastMinute' : 'LM',
    'JOB.Tag_Damage' : 'D',
    'JOB.Tag_ProtocolDefect' : 'PD',
    'JOB.Card_Hero_Hall' : 'Зал',
    'JOB.Card_Hero_Number' : '№ задачі',
    'JOB.Card_Hero_Block' : 'Блок',
    'JOB.Card_Hero_Stand' : 'Стенд',
    'JOB.Card_Hero_Exhibitor' : 'Експонент',
    'JOB.Button_Text_ToTheStand' : 'До стенду',
    'JOB.Text_Creator' : 'від { whoCreate } { whenCreate }',
    'JOB.Text_InWork' : 'від { whoWork } { whenWork }',
    'JOB.Text_Executor' : 'від { whoExecute } { whenExecute }',
    'JOB.Text_DurationTime' : 'Тривалість: { time }',
    'JOB.Type_Claim' : 'MP рекламація',
    'JOB.Type_AllClaims' : 'Рекламація',
    'JOB.Type_CustomerClaim' : 'Рекламація експонента',
    'JOB.Type_LastMinute' : 'Термінова задача',
    'JOB.Type_Damage' : 'Пошкодження',
    'JOB.Type_ProtocolDefect' : 'Дефект протоколу',
    'JOB.Button_ChangeStatus_Waiting' : 'Взяти задачу',
    'JOB.Button_ChangeStatus_InProgress' : 'Задача в роботі',
    'JOB.Button_ChangeStatus_Done' : 'Завершити задачу',
    'JOB.Modal_Title_Photo' : 'Фото задачі',
    'JOB.Filter_Params_JobType' : 'Тип: { withFilter }',
    'JOB.Filter_Params_CraftType' : 'Роботи: { withFilter }',
    'JOB.Modal_Title_NewJob' : 'Нова { jobType }',
    'JOB.Modal_Title_EditJob' : 'Редагувати { jobType }',
    'JOB.Button_Text_AddClaim' : 'Додати задачу MP рекламації',
    'JOB.Button_Text_AddCustomerClaim' : 'Додати задачу рекламації експонента',
    'JOB.Button_Text_AddLastMinute' : 'Додати термінову задачу',
    'JOB.Button_Text_AddDamage' : 'Додати фото пошкодження',
    'JOB.Button_Text_AddProtocolDefect' : 'Додати дефект протоколу',
    'DAMAGE.Card_Title' : 'Пошкодження у { exhibitor }',
    'DAMAGE.Modal_Title_Photo' : 'Пошкодження { exhibitor }',
    'DAMAGE.Status_Label_New' : 'Не перевірено',
    'DAMAGE.Status_Label_Check' : 'Перевірено',
    'DAMAGE.Status_Label_DCheck' : 'Затверджено',
    'DAMAGE.Button_Text_Stand' : 'Стенд',
    'DAMAGE.Button_Text_Photo' : 'Фото',
    'DAMAGE.Button_Text_AddNote' : "ДОДАТИ НОТАТКУ",
    'DAMAGE.Modal_Button_AddPhoto' : 'Додати фото',
    'DAMAGE.Modal_Button_CreateReport' : 'Створити звіт',
    'DAMAGE.Modal_Button_EditReport' : 'Редагувати звіт',
    'DAMAGE.AsCraft_label' : "Пошкодження",
    "DAMAGE.Button_Text_Open" : "Відкрити",
    "STAND.Block_Title_Damages" : "Пошкодження",
    'MENUS.Label_Overview' : 'Огляд',
    'MENUS.Label_Stands' : 'Стенди',
    'MENUS.Label_Jobs' : 'Задачі',
    'MENUS.Label_ExpoPlan' : 'План expo',
    'MENUS.Label_More' : 'Більше',
    'MENUS.Label_SelectExhibition' : 'Вибрати подію',
    'MENUS.Label_CraftsOverview' : 'Огляд робіт',
    'MENUS.Label_HallsOverview' : 'Огляд залів',
    'MENUS.Label_ViewDamages' : 'Переглянути пошкодження',
    'MENUS.Label_Downloads' : 'Файли',
    'MENUS.Label_Documents' : 'Документи',
    'MENUS.Label_FurnishingLeftovers' : 'Залишки обладнання',
    'MENUS.Label_HelpImprint' : 'Imprint',
    'MENUS.Label_CollectGraphics' : 'Забрати графіку',
    'NO_DATA.Exhibitions' : 'У вас ще немає подій.',
    'NO_DATA.Documents' : 'Поточна подія ще не має { br } документів.',
    'NO_DATA.Stands' : 'Стенди за запитом { br } не знайдено',
    'NO_DATA.StandPhoto' : 'У вас ще немає фото стенду',
    'NO_DATA.DamagePhoto' : 'У вас ще немає фото пошкоджень { br } цього стенду',
    'NO_DATA.Stand_NoKeys' : 'Цей стенд ще не має ключів',
    'NO_DATA.Stand_DoesNotExist' : 'Цей стенд не існує',
    'NO_DATA.Subcontractor_Unsigned' : 'Не призначено',
    'NO_DATA.Jobs' : 'Задачі за запитом { br } не знайдено',
    'NO_DATA.Damages' : 'Пошкодження за запитом { br } не знайдено',
    'NO_DATA.Hall' : 'Цей зал не існує',
    'NO_DATA.HallPlan' : 'Ми не знайшли план цього залу',
    'NO_DATA.Furnishing_Storage' : 'Ця подія не має { br } обладнання на складі',
    'NO_DATA.Furnishing_Orders' : 'Ця подія не має { br } замовлень обладнання',
    'PAGE.Title_Overview' : 'Огляд',
    'PAGE.Title_ExhibitionSelection' : 'Вибір події',
    'PAGE.Title_Stands' : 'Стенди',
    'PAGE.Title_Stand' : 'Стенд',
    'PAGE.Title_StandComments' : 'Коментарі стенду',
    'PAGE.Title_StandLog' : 'Лог стенду',
    'PAGE.Title_StandKeys' : 'Ключі стенду',
    'PAGE.Title_ViewDamages' : 'Переглянути пошкодження',
    'PAGE.Title_AdditionalMenu' : 'Додаткове меню',
    'PAGE.Title_Jobs' : 'Задачі',
    'PAGE.Title_ExpoPlan' : 'План expo',
    'PAGE.Title_Documents' : 'Документи',
    'PAGE.Title_FurnishingLeftovers' : 'LM обладнання',
    'PAGE.Title_FurnishingReturns' : 'Журнал змін обладнання',
    'PAGE.Title_HallPlan' : 'План залу',
    'PAGE.Title_HallsOverview' : 'Огляд залів',
    'PAGE.Title_CraftsOverview' : 'Огляд робіт',
    'PAGE.Title_HelpImprint' : 'Imprint',
    'PAGE.Title_CollectGraphics' : 'Забрати графіку',
    'SORT.Text_NewestByCreation' : 'Найновіші за датою створення',
    'SORT.Text_OldestByCreation' : 'Найстаріші за датою створення',
    'SORT.Text_ExhibitorNameAZ' : 'Назва експонента (A-Z)',
    'SORT.Text_ExhibitorNameZA' : 'Назва експонента (Z-A)',
    'SORT.Text_FinishedFirst' : 'Завершені спочатку',
    'SORT.Text_InProgressFirst' : 'Відкриті спочатку',
    'SORT.Text_StandNumberAZ' : 'Номер стенду (A-Z)',
    'SORT.Text_StandNumberZA' : 'Номер стенду (Z-A)',
    'SORT.Text_CorridorAZ' : 'Коридор (A-Z)',
    'SORT.Text_CorridorZA' : 'Коридор (Z-A)',
    'SORT.Text_BlockAZ' : 'Блок (A-Z)',
    'SORT.Text_BlockZA' : 'Блок (Z-A)',
    'SORT.Text_FlagFirst' : 'З позначкою спочатку',
    'SORT.Text_FlagLast' : 'Без позначки спочатку',
    'SORT.Text_HallAZ' : 'Зал (A-Z)',
    'SORT.Text_HallZA' : 'Зал (Z-A)',
    'SORT.Text_StatusAZ' : 'Затверджено',
    'SORT.Text_StatusZA' : 'Не перевірено',
    'STAND.Modal_Title_Search' : 'Пошук',
    'STAND.Input_Placeholder_Search' : 'Пошук',
    'STAND.Filter_Params_Exhibitor' : 'Експонент: { exhibitorName }',
    'STAND.Filter_Params_WithComments' : 'З коментарями',
    'STAND.Card_Hero_Hall' : 'Зал',
    'STAND.Card_Hero_Block' : 'Блок',
    'STAND.Card_Hero_Stand' : 'Стенд',
    'STAND.Card_Hero_DeliveryTime' : 'Час доставки',
    'STAND.Modal_Title_StandPlan' : 'Креслення стенду',
    'STAND.Modal_Button_StandPlan' : 'Креслення',
    'STAND.Card_Button_Details' : 'Деталі { icon }',
    'STAND.Modal_Title_StandPhoto' : 'Фото стенду',
    'STAND.Modal_Button_StandPhoto' : 'Фото',
    'STAND.Modal_Button_SavePhoto' : 'Зберегти фото',
    'STAND.Modal_Button_AddPhoto' : 'Додати фото',
    'STAND.Button_Text_Comments' : 'Коментарі',
    'STAND.Button_Text_AddComment' : 'Додати коментар',
    'STAND.Modal_Title_AddComment' : 'Додати коментар',
    'STAND.Modal_Title_EditComment' : 'Редагувати коментар',
    'STAND.Modal_Button_AddComment' : 'Додати',
    'STAND.Modal_Button_SaveComment' : 'Зберегти',
    'STAND.Text_NoComments' : 'Коментарів ще немає',
    'STAND.Text_AddFile' : 'Додати файл',
    'COMMENTS.Text_Uploading' : 'Завантаження...',
    'STAND.Text_EditComment' : 'Редагувати',
    'STAND.Text_DeleteComment' : 'Видалити',
    'STAND.Text_CommentDraftError' : 'Чернетка коментаря ще не готова',
    'STAND.Block_Title_Overview' : 'Огляд',
    'STAND.Block_Title_Materials' : 'Додаткова інформація',
    'STAND.Block_Title_Crafts' : 'Роботи',
    'STAND.Block_ItemTitle_Hall' : 'Зал',
    'STAND.Block_ItemTitle_Block' : 'Блок',
    'STAND.Block_ItemTitle_Stand' : 'Стенд',
    'STAND.Block_ItemTitle_ProaufNumber' : 'Номер Proauf',
    'STAND.Block_ItemTitle_Jobs' : 'Задачі',
    'STAND.Block_Item_JobCountInProgress' : '{ jobCount } в роботі',
    'STAND.Block_Item_JobCountOpen' : '{ jobCount } відкриті',
    'STAND.Block_Item_JobCountFinished' : '{ jobCount } завершені',
    'STAND.Block_Button_ViewStandJobs' : 'Переглянути задачі стенду',
    'STAND.Modal_Title_StandGraphic' : 'Графіка стенду',
    'STAND.Modal_Button_StandGraphic' : 'Графіка стенду',
    'STAND.Modal_Title_ExtraInfo' : 'Додаткова інформація',
    'STAND.Modal_Button_ExtraInfo' : 'Додаткова інформація',
    'STAND.Button_Text_ViewKeys' : 'Переглянути ключі',
    'STAND.Button_Text_ViewLogs' : 'Переглянути логи',
    'STAND.Modal_Button_AddKey' : 'Додати ключ',
    'STAND.Modal_Title_AddKey' : 'Додати ключ',
    'STAND.Modal_Title_EditKey' : 'Редагувати ключ',
    'STAND.Modal_Button_UpdateKey' : 'Оновити ключ',
    'STAND.Filter_Params_Stand' : 'Стенд { withFilter }',
    'STAND.Button_Text_DeleteKey' : 'Видалити',
    'STAND.Text_ModalDelete_Question' : 'Ви впевнені, що хочете видалити ключ { keyName }?',
    'STAND.External_Exhibition' : 'Подія, до якої ви не призначені',
    'JOB.Button_Text_ViewPhoto' : 'Переглянути фото',
    'OVERVIEW_TYPES.Label_InTotal' : 'загалом',
    'OVERVIEW_TYPES.Label_Finished' : 'завершено',
    'OVERVIEW_TYPES.Label_Open' : 'відкрито',
    'OVERVIEW_TYPES.Label_Claims' : 'рекламації',
    'OVERVIEW_TYPES.Label_LastMinute' : 'термінові',
    'OVERVIEW_TYPES.Label_Overdue' : 'прострочено',
    'FURNISHING.TabName_Storage' : 'Склад',
    'FURNISHING.TabName_Refund' : 'Повернення',
    'FURNISHING.TabName_OrderLog' : 'Журнал замовлень',
    'FURNISHING.Modal_Title_ReturnFurnishing' : 'Кількість LM обладнання',
    'FURNISHING.Modal_Title_FurnishingStore' : 'Обладнання на складі',
    'FURNISHING.Button_Text_Return' : 'Повернути',
    'FURNISHING.Button_Text_ChooseFurnishing' : 'Вибрати обладнання',
    'FURNISHING.Modal_Title_Photo' : "Фото обладнання",
    'FURNISHING.Order_Type_Refund' : "Повернення",
    'FURNISHING.Order_Type_Lost' : "Втрачено",
    'FURNISHING.Order_Type_Correction' : "Корекція",
    'FURNISHING.Order_Type_Order' : "Замовлення",
};

export default ukrainian;
